import React, { useRef, useState } from "react";
import "./Contact.css";
import PageBanner from "../components/PageBanner";
//import contactBanner from "../assets/about-banner1.JPG";
import contactBanner from "../assets/slide2.png";
import CustomTitle from "../components/CustomTitle";
import emailjs from "@emailjs/browser";
const Contact = () => {
  const formRef = useRef();
  const [form, setForm] = useState({
    name: "",
    email: "",
    message: "",
    mobile: "",
  });
  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });
  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_r0mrz6x", // <-- replace with your actual service ID
        "template_p7o1gwu", // <-- replace with your actual template ID
        formRef.current,
        "DgeZGxN92I2VhtNt0" // <-- replace with your actual public key
      )
      .then(
        (result) => {
          alert("Thank you! Your message has been sent.");
          setForm({ name: "", email: "", message: "", mobile: "" });
        },
        (error) => {
          alert("Oops! Something went wrong. Please try again later.");
          setForm({ name: "", email: "", message: "", mobile: "" });
        }
      );
  };
  return (
    <>
      <PageBanner
        image={contactBanner}
        title="Legal Expertise You Can Rely On"
      />
      <section className="contact-section">
        <CustomTitle>Contact Us</CustomTitle>
        <div className="contact-content">
          <form className="contact-form" onSubmit={handleSubmit} ref={formRef}>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              required
              value={form.name}
              onChange={handleChange}
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              required
              value={form.email}
              onChange={handleChange}
            />
            <input
              type="text"
              name="mobile"
              placeholder="Your Mobile Number"
              required
              value={form.mobile}
              onChange={handleChange}
            />
            <textarea
              name="message"
              rows={5}
              placeholder="How can we help you?"
              required
              value={form.message}
              onChange={handleChange}
            />
            <button className="ctaButton" type="submit">
              Send Message
            </button>
          </form>
          <div className="contact-info">
            <h4>Office Address</h4>
            <p>
              Plot 131, <br />
              Prashant Vihar, <br />
              near Raghu Engineering college, Dakamarri <br />
              Visakhapatnam -531162
            </p>
            <h4>Phone</h4> <p>9702004242 / 9010903484</p>
            <h4>Email</h4> <p>kav@kasibhatlaws.in</p>
          </div>
        </div>
        <div className="contact-map">
          <iframe
            title="Law Office Location"
            /*  src="https://www.google.com/maps?q=Plot+131,+Prashant+Vihar,+near+Raghu+Engineering+college,+Dakamarri,+Visakhapatnam+-+531162&output=embed" */
            src="https://www.google.com/maps?q=17.98054,83.41203&hl=es;z=14&output=embed"
            width="100%"
            height="260"
            style={{ border: 0, borderRadius: "1em" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
        {/* <div style={{ marginTop: "1em", textAlign: "center" }}> <a href="https://www.google.com/maps/search/?api=1&query=Plot+131,+Prashant+Vihar,+near+Raghu+Engineering+college,+Dakamarri,+Visakhapatnam+-+531162" target="_blank" rel="noopener noreferrer" style={{ color: "#007bff", textDecoration: "underline" }} > View on Google Maps </a> </div> */}{" "}
      </section>
    </>
  );
};
export default Contact;
